<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <div class="tab">
    <HeatingControllerControlView v-if="device.info.device_type == 'DOMX_HC_OT'" :device="device" />
    <MBControlView v-else-if="device.info.device_type == 'DOMX_HC_MB'" :device="device"/>
    <IAQControlView v-if="device.info.device_type == 'DOMX_IAQ'" :device="device" />
    <SinglePhaseEnergyMeterControlView v-if="device.info.device_type == 'SHELLY_EM_1PH'" :device="device" />
    <ThreePhaseEnergyMeterControlView v-if="device.info.device_type == 'SHELLY_EM_3PH'" :device="device" />
  </div>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import HeatingControllerControlView from './heating_controller_ot/HeatingControllerControlView.vue';
import IAQControlView from './iaq/IAQControlView.vue';
import SinglePhaseEnergyMeterControlView from './energy_meter/SinglePhaseEnergyMeterControlView.vue';
import ThreePhaseEnergyMeterControlView from './energy_meter/ThreePhaseEnergyMeterControlView.vue';
import MBControlView from './heating_controller_mb/MBControlView.vue';

@Component({
  components: {
    HeatingControllerControlView,
    MBControlView,
    IAQControlView,
    SinglePhaseEnergyMeterControlView,
    ThreePhaseEnergyMeterControlView,
  }
})

export default class DevicesSideviewGeneralTab extends Vue {
  @Prop() device: Record<string, any>;      
};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
